import { Trans } from '@lingui/react/macro'
import {
  Stack,
  Card,
  Text,
  Group,
  Box,
  UnstyledButton,
  Badge,
} from '@mantine/core'
import { IconSparkles, IconStar, IconChevronRight } from '@tabler/icons-react'

interface FeedItemProps {
  type: 'rating' | 'news'
  title: string
  description?: string
  badge?: string
  onClick?: () => void
}

function FeedItem({ type, title, description, badge, onClick }: FeedItemProps) {
  const getIcon = () => {
    switch (type) {
      case 'rating':
        return <IconStar size={20} color="var(--mantine-color-yellow-6)" />
      case 'news':
        return (
          <IconSparkles size={20} color="var(--mantine-color-brandOrange-6)" />
        )
    }
  }

  return (
    <UnstyledButton onClick={onClick} style={{ width: '100%' }}>
      <Card
        radius="md"
        withBorder
        p="sm"
        style={{
          transition: 'all 0.2s',
          cursor: 'pointer',
        }}
        styles={{
          root: {
            '&:hover': {
              transform: 'translateX(4px)',
              borderColor: 'var(--mantine-color-brandOrange-3)',
            },
          },
        }}
      >
        <Group justify="space-between" align="center" wrap="nowrap">
          <Group gap="md" wrap="nowrap">
            <Box
              style={{
                width: 40,
                height: 40,
                borderRadius: 8,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                background:
                  type === 'rating'
                    ? 'var(--mantine-color-yellow-0)'
                    : 'var(--mantine-color-brandOrange-0)',
              }}
            >
              {getIcon()}
            </Box>
            <Stack gap={0}>
              <Group gap="xs">
                <Text fw={600}>{title}</Text>
                {badge && (
                  <Badge color="brandOrange" variant="light">
                    {badge}
                  </Badge>
                )}
              </Group>
              {description && <Text c="dimmed">{description}</Text>}
            </Stack>
          </Group>
          <IconChevronRight size={18} color="var(--mantine-color-gray-5)" />
        </Group>
      </Card>
    </UnstyledButton>
  )
}

export function ActivityFeed() {
  // Mock data - would come from API based on user activity
  const feedItems: FeedItemProps[] = [
    {
      type: 'rating',
      title: 'Give feedback on visit',
      description: 'Markku visited 28.11.2024',
      onClick: () => console.log('Rate visit'),
    },
    {
      type: 'news',
      title: 'Chimney sweep added to Plus package!',
      description: 'Chimney sweep at no extra cost',
      onClick: () => console.log('Read more'),
    },
  ]

  if (feedItems.length === 0) {
    return null
  }

  return (
    <Stack gap="md">
      <Text size="md" fw={600}>
        <Trans>News</Trans>
      </Text>
      <Stack gap="xs">
        {feedItems.map((item, index) => (
          <FeedItem key={index} {...item} />
        ))}
      </Stack>
    </Stack>
  )
}
